import CustomData from "pages/_components/CustomData/CustomData";
import React, { useEffect, useState } from "react";
import * as config from "util/config";
import * as i18n from "util/i18n";

const MepDisclaimer = () => {
    const [disclaimer, setDisclaimer] = useState("");

    useEffect(() => {
        const startingHour = config.getInteger("bibank.mep.startingHour", 16);
        const closingHour = config.getInteger("bibank.mep.closingHour", 18);

        const msg = i18n.get("transfer.mep.disclaimer", "", { CLOSING_HOUR: closingHour, STARTING_HOUR: startingHour });
        setDisclaimer(msg);
    }, []);

    return (
        <div className="container--alert" role="alert">
            <div className="alert alert-info">
                <CustomData
                    icon="information_fill.svg"
                    titleText={disclaimer}
                    titleTextType="TEXT"
                    keepSpaceIfNoValue={false}
                />
            </div>
        </div>
    );
};

export default MepDisclaimer;
